import { createRouter, createWebHistory } from "vue-router";
import {
    ERROR_PATH,
    MODE_PATH,
    GUIDE_PATH,
    HOME_PATH,
    PORTAL_PATH,
    ORGANIZATION_PATH,
    INDIVIDUALS_PATH,
} from "@/constants/route";
import { useUserInfo } from "@/hooks/useUserInfo";
import { getWhiteBool } from "@/utils/fetch";

const { isWhiteList, userInfo } = useUserInfo();

const router = createRouter({
    history: createWebHistory("/"),
    routes: [
        {
            path: PORTAL_PATH,
            name: "portal",
            component: () => import("@/views/portal/portal.vue"),
        },

        {
            path: ORGANIZATION_PATH,
            name: "organization",
            component: () => import("@/views/apply/organization/index.vue"),
        },

        {
            path: INDIVIDUALS_PATH,
            name: "individuals",
            component: () => import("@/views/apply/individuals/index.vue"),
        },
        {
            path: HOME_PATH,
            name: "home",
            component: () => import("@/views/home/home.vue"),
            redirect: "home/data/sell-data",
            children: [
                {
                    path: "data",
                    children: [
                        {
                            path: "sell-data",
                            name: "sell-data",
                            component: () => import("@/views/data/sell-data/index.vue"),
                        },
                        {
                            path: "core-data",
                            name: "core-data",
                            component: () => import("@/views/data/core-data/index.vue"),
                        },
                        {
                            path: "ad-serving",
                            name: "ad-serving",
                            component: () => import("@/views/data/ad-serving/index.vue"),
                        },
                        {
                            path: "saler-data",
                            name: "saler-data",
                            component: () => import("@/views/data/saler-data/index.vue"),
                        },
                        {
                            path: "iaa-ad-data",
                            name: "iaa-ad-data",
                            component: () => import("@/views/data/iaa-ad-data/index.vue"),
                        },
                        {
                            path: "ad-social-data",
                            name: "ad-social-data",
                            component: () => import("@/views/data/ad-social-data/index.vue"),
                        },
                    ],
                },
                {
                    path: "content",
                    children: [
                        {
                            path: "content-management",
                            name: "content-management",
                            component: () => import("@/views/skit-content-management/index.vue"),
                            meta: {
                                keepAlive: true, // 不需要被缓存
                            },
                        },
                        {
                            path: "content-management/edit",
                            name: "content-management-edit",
                            component: () => import("@/views/skit-content-management/new-skit.vue"),
                            meta: {
                                activeMenu: "content-management",
                                keepAlive: true, // 不需要被缓存
                            },
                        },
                        {
                            path: "content-management/detail",
                            name: "content-management-detail",
                            component: () => import("@/views/skit-content-management/detail.vue"),
                            meta: {
                                activeMenu: "content-management",
                                keepAlive: true, // 不需要被缓存
                            },
                        },
                    ],
                },
                {
                    path: "cash",
                    children: [
                        {
                            path: "cash-manage",
                            name: "cash-manage",
                            component: () => import("@/views/cash/cash-manage/index.vue"),
                        },
                        {
                            path: "account-manage",
                            name: "account-manage",
                            component: () => import("@/views/cash/account-manage/index.vue"),
                        },
                        {
                            path: "finance-report",
                            name: "finance-report",
                            component: () => import("@/views/cash/finance-report/index.vue"),
                        },
                        {
                            path: "earnest-money",
                            name: "earnest-money",
                            component: () => import("@/views/cash/earnest-money/index.vue"),
                        },
                    ],
                },

                {
                    path: "marketing",
                    children: [
                        {
                            path: "episode-range-sale",
                            name: "episode-range-sale",
                            component: () => import("@/views/marketing/episode-range-sale/index.vue"),
                        },
                        {
                            path: "episode-range-sale/package-new",
                            name: "episode-range-sale/package-new",
                            component: () => import("@/views/marketing/episode-range-sale/package-new.vue"),
                            meta: {
                                activeMenu: "marketing",
                            },
                        },
                        {
                            path: "episode-range-sale/new",
                            name: "episode-range-sale/new",
                            component: () => import("@/views/marketing/episode-range-sale/new.vue"),
                            meta: {
                                activeMenu: "marketing",
                            },
                        },
                        {
                            path: "episode-range-sale/detail",
                            name: "episode-range-sale/detail",
                            component: () => import("@/views/marketing/episode-range-sale/detail.vue"),
                            meta: {
                                activeMenu: "marketing",
                            },
                        },
                        {
                            path: "homepage-decoration",
                            name: "homepage-decoration",
                            component: () => import("@/views/marketing/decoration.vue"),
                        },
                        {
                            path: "virtual-gold",
                            name: "virtual-gold",
                            component: () => import("@/views/marketing/virtual-gold/index.vue"),
                        },
                        {
                            path: "virtual-gold/new",
                            name: "virtual-gold/new",
                            component: () => import("@/views/marketing/virtual-gold/new.vue"),
                            meta: {
                                activeMenu: "marketing",
                            },
                        },
                        {
                            path: "virtual-gold/detail",
                            name: "virtual-gold/detail",
                            component: () => import("@/views/marketing/virtual-gold/detail.vue"),
                            meta: {
                                activeMenu: "marketing",
                            },
                        },
                    ],
                },
                {
                    path: "distribution",
                    children: [
                        {
                            path: "distribution-manage",
                            name: "distribution-manage",
                            component: () => import("@/views/distribution/distribution-manage/index.vue"),
                            meta: {
                                activeMenu: "distribution-manage",
                                keepAlive: true, // 不需要被缓存
                            },
                        },
                        {
                            path: "distribution-list-management",
                            name: "distribution-list-management",
                            component: () => import("@/views/skit-content-management/index.vue"),
                            meta: {
                                activeMenu: "distribution-manage",
                                keepAlive: true, // 不需要被缓存
                            },
                        },
                        {
                            path: "distribution-list-management/detail",
                            name: "distribution-list-management-detail",
                            component: () => import("@/views/skit-content-management/detail.vue"),
                            meta: {
                                activeMenu: "distribution-manage",
                                keepAlive: true, // 不需要被缓存
                            },
                        },
                        {
                            path: "distribution-list-management/edit",
                            name: "distribution-list-management-edit",
                            component: () => import("@/views/skit-content-management/new-skit.vue"),
                            meta: {
                                activeMenu: "distribution-manage",
                                keepAlive: true, // 不需要被缓存
                            },
                        },
                    ],
                },
                {
                    path: "account",
                    children: [
                        {
                            path: "account-number-management",
                            name: "account-number-management",
                            component: () => import("@/views/account/account-number-manage/index.vue"),
                        },
                    ],
                },
            ],
        },
        {
            path: GUIDE_PATH,
            name: "guide",
            component: () => import("@/views/guide/index.vue"),
        },
        {
            path: MODE_PATH,
            name: "mode",
            component: () => import("@/views/mode/index.vue"),
        },
        {
            path: ERROR_PATH,
            name: "error",
            component: () => import("@/views/error/api-error.vue"),
        },
        {
            path: "/:pathMatch(.*)",
            name: "not-found",
            component: () => import("@/views/error/not-found.vue"),
        },
    ],
});
router.beforeResolve(async (to) => {
    if (
        userInfo.value?.bizIdentity === 3 &&
        (to.name === "sell-data" || to.name === "core-data" || to.name === "ad-serving" || to.name === "saler-data")
    ) {
        return {
            name: "iaa-ad-data",
        };
    }
});
router.beforeEach(async (to) => {
    if (to.name !== "sell-data" && to.name !== "core-data" && to.name !== "ad-serving") {
        return;
    }

    if (isWhiteList.value === undefined) {
        isWhiteList.value = await getWhiteBool();
    }

    if (isWhiteList.value && to.name === "sell-data") {
        return {
            name: "core-data",
        };
    }

    if (!isWhiteList.value && (to.name === "core-data" || to.name === "ad-serving")) {
        return {
            name: "sell-data",
        };
    }
});

export default router;
